var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileTypesPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1998D5",
    d: "M21 6h-5.25a.75.75 0 01-.75-.75V0H4.125C3.505-.002 3.002.5 3 1.12v21.755c-.002.62.5 1.123 1.12 1.125h15.755c.62.002 1.123-.5 1.125-1.12V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.285 18.047c-.315-.362-.774-.612-1.293-.706-.821-.149-1.6-.203-2.333-.19-.667-.678-1.311-1.479-1.751-2.359.385-1.279.588-2.385.703-3.008.059-.32-.03-.661-.236-.912a1.007 1.007 0 00-.775-.372h-.001c-.29 0-.535.12-.71.344-.588.755-.187 2.58-.1 2.94.089.363.215.718.37 1.061-.305.97-.716 2.022-1.273 3.018-1.86.683-2.967 1.622-3.058 1.701-.308.303-.46.606-.453.903.005.168.065.417.325.645.199.175.454.263.713.263.262 0 .53-.09.746-.27.897-.744 1.616-1.668 2.193-2.648a10.976 10.976 0 013.037-.587 17.071 17.071 0 002.17 1.782c.55.38 1.284.331 1.747-.116.433-.419.425-.976-.021-1.489zm-9.49 2.46c-.174.148-.43.158-.58.023-.059-.053-.089-.1-.09-.143 0-.034.015-.166.236-.388.016-.014.744-.642 2.014-1.249a9.14 9.14 0 01-1.58 1.758zm3.642-9.178c.042-.049.087-.079.185-.079.14 0 .23.078.272.125a.41.41 0 01.099.35 29.01 29.01 0 01-.5 2.15l-.021-.079c-.209-.795-.357-2.086-.035-2.467zm-.562 6.296c.3-.627.551-1.261.761-1.875.326.546.71 1.055 1.114 1.518-.676.069-1.302.196-1.875.357zm5.89 1.302c-.234.244-.616.265-.907.05-.399-.297-.983-.76-1.608-1.352.488.025.995.084 1.518.185.38.074.711.265.932.537.285.352.158.484.065.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FC",
    d: "M20.672 4.922L16.082.328A1.122 1.122 0 0015.286 0H15v5.25c0 .414.336.75.75.75H21v-.286a1.12 1.12 0 00-.328-.792z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.6 2.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7.2,
    fill: "#FFF",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A99F9",
    d: "M2.43 2.1c.512 0 .884.098 1.118.295.235.196.352.499.352.907 0 .41-.12.708-.359.898-.24.19-.606.285-1.1.285h-.598v.99h-.568V2.1h1.156zm3.363 0c.597 0 1.056.147 1.376.442.321.294.481.704.481 1.229 0 .524-.155.94-.467 1.245-.31.306-.787.459-1.428.459H4.65V2.1h1.143zm4.857 0l-.005.531H8.97v.927h1.496v.526H8.97v1.391H8.4V2.1h2.25zm-4.876.526h-.562V4.94h.624c.403 0 .712-.097.926-.292.214-.195.321-.482.321-.862 0-.772-.436-1.159-1.31-1.159zm-3.353-.01h-.578V3.97h.66c.315 0 .53-.06.643-.181.114-.121.171-.298.171-.532 0-.233-.072-.398-.217-.495-.144-.096-.37-.144-.679-.144z"
  })))));
}

export default SvgFileTypesPdf;